import React from 'react'
import { motion } from 'motion/react'
import type { FieldValues } from '../../fieldTypes'

export function ButtonHover({ values = {} }: { values?: FieldValues }) {
  const hoverScale = values.hoverScale ?? 1.05
  const tapScale = values.tapScale ?? 0.97
  const stiffness = values.stiffness ?? 400
  const damping = values.damping ?? 17
  const bgColor = values.bgColor ?? 'bg-indigo-600'

  return (
    <div className="flex items-center justify-center h-full">
      <motion.button
        whileHover={{ scale: hoverScale }}
        whileTap={{ scale: tapScale }}
        transition={{ type: 'spring', stiffness, damping }}
        className={`px-6 py-3 ${bgColor} text-white text-sm font-semibold rounded-lg shadow-md cursor-pointer`}
      >
        Hover Me
      </motion.button>
    </div>
  )
}
